import { render, staticRenderFns } from "./whBatchOrder.vue?vue&type=template&id=17918520&scoped=true&"
import script from "./whBatchOrder.vue?vue&type=script&lang=js&"
export * from "./whBatchOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17918520",
  null
  
)

export default component.exports